import "./shortlink.scss";

import moment from "moment";
import pluralize from "pluralize";
import Loading from "../../../common/Loading";
import RewardList from "./components/RewardList";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../../../utils/constants/isEmpty";
import React, { useEffect, useState, useMemo } from "react";
import FeedbackModal from "./components/FeedbackModal.jsx";
import NegFbActionTerms from "./components/NegFbActionTerms";
import SbEmptyState from "../../../common/Cards/SbEmptyState";
import NegFbDetailHead from "./components/NegFbDetailHead.jsx";
import NegFbDetailCard from "./components/NegFbDetailCard.jsx";
import LockedLoyaltyCard from "./components/LockedLoyaltyCard";
import CompleteProfileCard from "./components/CompleteProfileCard";
import PoweredByReeloFooter from "./components/PoweredByReeloFooter";
import { useLocation, useParams, useHistory } from "react-router-dom";
import ShortlinkStoreDetails from "./components/ShortlinkStoreDetails";
import ExistingCustomerModal from "./components/ExistingCustomerModal";
import CampaignCard from "../../../common/Pages/ShortLinks/CampaignCard";
import { loyaltyMembShortlinkTabs } from "../../Private/Membership/utils";
import AllStoreBottomStickyMenu from "./components/AllStoreBottomStickyMenu";
import WhatsappOptOut from "../../../common/Pages/ShortLinks/WhatsappOptOut";
import TabSelectButtonGroup from "../../../common/Buttons/TabSelectButtonGroup";
import { redirectToDifferentPage } from "../../../../utils/constants/constants";
import MembershipLandingPage from "../../Private/Membership/Components/LandingPage";
import NoDiscountCampCard from "../../../common/Pages/ShortLinks/NoDiscountCampCard";
import QrCodeLandingPage from "../../Private/QrCode/Edit/Components/QrCodeLandingPage/FinalPage";
import QrCodeRewardPage from "../../Private/QrCode/Edit/Components/QrCodeLandingPage/QrCodeRewardPage";
import SubscribedMemberships from "../../Private/Membership/Components/LandingPage/SubscribedMemberships";
import FinalExistingB2cLp from "../../Private/B2cReferral/Edit/Components/B2cLandingPages/Final/FinalExisting";
import {
  setSortlinkDetails,
  getShortlinkRewards,
  setTemplateSortlinkDetails,
  getSubscribedMembershipsRewards,
} from "../../../../redux/actions/shortlinkActions";

const LoyaltyShortlink = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [isFbModal, toggleFbModal] = useState(0);
  const [fbActiveStep, setFbActiveStep] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [isReferralModal, toggleReferralModal] = useState(false);
  const [isLoadingRewards, toggleLoadingRewards] = useState(false);

  // campaign, auto-campaign, qr and referral rewards
  const [otherRewards, setOtherRewards] = useState([]);

  const [membPurchaseDetails, setMembPurchaseDetails] = useState({});
  const [isLoadingMemberships, toggleLoadingMemberships] = useState(false);
  const [isShowLoyaltyAndMembTabs, showLoyaltyAndMembTabs] = useState(false);
  const [activeTabForLoyaltyAndMemb, setActiveTabForLoyaltyAndMemb] =
    useState("loyalty"); // loyalty, membership

  const shortlinkData = useSelector((state) => state.shortLink);

  const initData = shortlinkData?.initData;
  const initTemplateData = shortlinkData?.initTemplateData;
  const campTemplateData = initTemplateData?.campaign;

  const subsMembs = shortlinkData?.subscribedMemberships || [];
  const subsMembsIds = shortlinkData?.subscribedMembershipIds || [];

  const campData = initData?.campaign;
  const shortLinkType = initData?.type;
  const loyaltyData = initData?.loyalty;
  const storeName = initData?.store?.name;
  const groupName = initData?.group?.name;
  const customerData = initData?.customer;
  const activeStores = initData?.active_stores;
  const currencyView = initData?.currency ?? "";
  const isProfileComplete = initData?.profile_complete;
  const isCashbackLoyalty = loyaltyData?.type === "cashback";
  const storeId = initData?.store?.id || initData?.store?._id;
  const groupId = initData?.group?.id || initData?.group?._id;
  const pointsBranding = loyaltyData?.settings?.points_branding;

  const reviewLink =
    initData?.feedback?.settings?.online_review?.review_links[0]?.link;

  const isTabletFeedbackActive = initData?.feedback?.settings?.channels?.find(
    (channel) => channel?.name === "tablet"
  )?.status;
  const isImmediateFeedback =
    initData?.feedback?.settings?.feedback_delay?.trigger === "immediately";

  const isShowFeedback = useMemo(
    () =>
      (isImmediateFeedback
        ? initData?.type === "loyalty" ||
          initData?.type === "feedback" ||
          initData?.type === "loyalty_test" ||
          initData?.type === "loyalty_redemption"
        : initData?.type === "feedback") &&
      !isEmpty(initData?.feedback) &&
      !isEmpty(initData?.feedback?.data) &&
      checkFbExpiry(
        initData?.feedback?.settings?.feedback_delay,
        initData?.feedback?.data?.txn?.created_at
      ) &&
      !isTabletFeedbackActive &&
      initData?.feedback?.data?.status === "sent" &&
      initData?.feedback_type !== "negative_feedback" &&
      (initData?.feedback?.settings?.is_active ||
        (initData?.feedback?.settings?.is_draft &&
          initData?.feedback?.data?.txn?.type === "test")),
    [initData]
  );

  let membershipList =
    initData?.memberships?.length > 0
      ? initData?.memberships
      : [
          {
            membership: initData?.membership,
            rewards: initData?.rewards,
            expires_at: initData?.expires_at,
          },
        ];

  if (subsMembsIds?.length > 0 && initData?.isFilterSubsMembs)
    membershipList = membershipList?.filter(
      (memb) => !subsMembsIds?.includes(memb?.membership?._id)
    );

  const isValidMembershipLink =
    shortLinkType === "membership_test" ||
    shortLinkType === "membership_test_communication" ||
    (shortLinkType === "membership"
      ? ((("is_promotion_active" in initData &&
          initData?.is_promotion_active) ||
          ("promotion_source" in initData &&
            (initData?.promotion_source === "in_store" ||
              initData?.promotion_source === "campaign"))) &&
          "memberships" in initData &&
          initData?.memberships?.length > 0) ||
        ("membership" in initData && !isEmpty(initData?.membership))
      : false);
  const isShowEmptyState =
    (isEmpty(initData) && isEmpty(initTemplateData)) ||
    (shortLinkType === "membership" && !isValidMembershipLink);

  useEffect(() => {
    if (params.code) {
      if (params.code === "referral") {
        history.replace("/");
      } else {
        let queryParams = "";
        if (location?.search) {
          const query = new URLSearchParams(location.search);
          const isCache = query.get("cache");
          const qrWaScanKey = query.get("key");
          const isTestShortlink = query.get("test");

          const failedReason = query.get("reason");
          const membPaymentStatus = query.get("status");
          const membershipId = query.get("membership_setting_id");

          if (membPaymentStatus?.length > 0 && membershipId?.length > 0)
            setMembPurchaseDetails({
              reason: failedReason,
              status: membPaymentStatus,
              membershipId: membershipId,
            });

          if (isTestShortlink)
            queryParams = `?type=feedback_reputation&test=true`;
          if (isCache) {
            queryParams = `${queryParams ? "&" : "?"}cache=true`;
          }
          if (qrWaScanKey)
            queryParams += `${queryParams ? "&" : "?"}key=${qrWaScanKey}`;
        }
        dispatch(setSortlinkDetails(params.code, queryParams))
          .then(() => setIsLoading(false))
          .catch(() => setIsLoading(false));
      }
    } else if (params.templateCode)
      dispatch(setTemplateSortlinkDetails(params.templateCode))
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      shortLinkType === "loyalty" ||
      shortLinkType === "feedback" ||
      shortLinkType === "loyalty_redemption"
    ) {
      fetchOtherRewards(storeId, customerData?.id);
      fetchSubscribedMembership(customerData?.id, groupId || storeId);
    }
  }, [storeId, groupId, shortLinkType, customerData?.id]);

  useEffect(() => {
    if (
      shortLinkType === "feedback_reputation" &&
      params.code !== localStorage?.review_short_code
    ) {
      localStorage.setItem("review_short_code", params.code);
      redirectToDifferentPage(reviewLink, "_self");
    }
  }, [reviewLink, shortLinkType, params.code]);

  useEffect(() => {
    if (shortLinkType === "fraud_list") {
      redirectToDifferentPage(initData?.export_url, "_self");
    }
    if (shortLinkType === "campaign_file") {
      redirectToDifferentPage(initData?.file_url, "_self");
    }
    if (shortLinkType === "campaign_custom") {
      const url = initData?.redirect_url?.includes("http")
        ? initData?.redirect_url
        : `https://${initData?.redirect_url}`;

      redirectToDifferentPage(url, "_self");
    }
    if (shortLinkType === "qr_code_external_link") {
      const url = initData?.external_link?.includes("http")
        ? initData?.external_link
        : `https://${initData?.external_link}`;

      redirectToDifferentPage(url, "_self");
    }
  }, [
    shortLinkType,
    initData?.file_url,
    initData?.export_url,
    initData?.redirect_url,
    initData?.external_link,
  ]);

  useEffect(() => {
    if (isShowFeedback) {
      toggleFbModal(true);
    }
  }, [isShowFeedback]);

  // for fetching campaign, auto-campaign, qr and referral rewards
  const fetchOtherRewards = (storeId, customerId) => {
    if (!storeId || !customerData?.id) return;

    toggleLoadingRewards(true);
    getShortlinkRewards(storeId, customerId)
      .then((payload) => {
        setOtherRewards(
          payload?.filter(
            (reward) =>
              (reward.is_active && reward.reward_type === "campaign") || // for campaign and auto-campaign rewards
              reward?.redemption?.applicable_stores || // for QR reward
              reward?.new_customer_referral_reward || // for b2c new customer reward
              reward?.existing_customer_referral_reward // for b2c existing customer reward
          )
        );
        toggleLoadingRewards(false);
      })
      .catch(() => toggleLoadingRewards(false));
  };

  const fetchSubscribedMembership = (customerId, entityId) => {
    if (!customerId || !entityId) return;

    const query = {
      entityId,
      customerId,
    };

    toggleLoadingMemberships(true);
    dispatch(getSubscribedMembershipsRewards(query))
      .then((payload) => {
        toggleLoadingMemberships(false);
        if (payload?.length > 0) showLoyaltyAndMembTabs(true);
      })
      .catch(() => toggleLoadingMemberships(false));
  };

  return isLoading || isLoadingRewards || isLoadingMemberships ? (
    <Loading />
  ) : (
    <div className="shortlink-root">
      {params.code && !isEmpty(initData) && (
        <>
          {shortLinkType === "campaign" ||
          shortLinkType === "auto_campaign_reminder" ? (
            <>
              <div className="campaign-shortlink-root">
                {campData?.reward?.type === "no_discount" ? (
                  <NoDiscountCampCard
                    campData={campData}
                    storeName={storeName}
                  />
                ) : (
                  <CampaignCard
                    data={campData}
                    storeName={storeName}
                    currencyView={currencyView}
                  />
                )}
              </div>
              {!isProfileComplete && (
                <CompleteProfileCard
                  loyaltyData={loyaltyData}
                  customerData={customerData}
                  setIsLoading={setIsLoading}
                  currencyView={currencyView}
                  isCashbackLoyalty={isCashbackLoyalty}
                />
              )}
            </>
          ) : shortLinkType === "feedback_reputation" ? (
            <div className="feedback_reputation">
              {params.code === localStorage?.review_short_code ? (
                <p>Loading ...</p>
              ) : (
                <p>
                  Redirect to{" "}
                  <span
                    onClick={() => redirectToDifferentPage(reviewLink, "_self")}
                  >
                    {reviewLink}
                  </span>
                </p>
              )}
            </div>
          ) : shortLinkType === "loyalty" ||
            shortLinkType === "feedback" ||
            shortLinkType === "loyalty_test" ||
            shortLinkType === "loyalty_redemption" ? (
            <>
              {initData?.feedback_type === "negative_feedback" ? (
                <div className="neg-fb">
                  <NegFbDetailHead
                    storeName={storeName}
                    fbGiven={initData?.feedback?.data}
                    cardData={initData?.feedback?.settings}
                  />
                  <NegFbDetailCard
                    storeName={storeName}
                    currencyView={currencyView}
                    custData={initData?.customer}
                    fbGiven={initData?.feedback?.data}
                    cardData={initData?.feedback?.settings}
                    purchaseNumber={initData?.purchase_number}
                  />
                </div>
              ) : (
                <>
                  {activeTabForLoyaltyAndMemb === "loyalty" ? (
                    <div className="fb-and-loyalty-shortlink-root">
                      <div
                        className="welcome-user-banner"
                        style={{
                          color:
                            initData?.loyalty?.colors?.text ||
                            initData?.feedback?.settings?.colors?.text,
                          backgroundColor:
                            initData?.loyalty?.colors?.theme ||
                            initData?.feedback?.settings?.colors?.theme,
                        }}
                      >
                        <div className="center-container">
                          <h3>Hello {customerData?.name}</h3>
                          {initData?.total_points > 0 && (
                            <p>
                              You have{" "}
                              <b>
                                {!pointsBranding?.active &&
                                loyaltyData?.type === "cashback"
                                  ? currencyView
                                  : ""}
                                {initData?.total_points}{" "}
                                {loyaltyData?.type === "cashback"
                                  ? pointsBranding?.active
                                    ? pluralize(
                                        pointsBranding?.name,
                                        initData?.total_points
                                      )
                                    : "Cash"
                                  : pluralize(
                                      pointsBranding?.active
                                        ? pointsBranding?.name
                                        : "point",
                                      initData?.total_points
                                    )}
                              </b>{" "}
                              {getExpiryText(
                                initData?.last_transaction_date,
                                loyaltyData?.settings?.points_expiry
                              )}
                            </p>
                          )}
                          <ReferralButton
                            initData={initData}
                            shortLinkType={shortLinkType}
                            isReferralModal={isReferralModal}
                            toggleReferralModal={toggleReferralModal}
                          />
                        </div>
                      </div>
                      <div className="fb-and-loyalty-shortlink">
                        <ShortlinkStoreDetails
                          loyaltyData={loyaltyData}
                          fbData={initData?.feedback?.settings}
                          storeName={
                            groupName?.length > 0 && activeStores?.length > 1
                              ? groupName
                              : storeName
                          }
                        />

                        <RewardList
                          currencyView={currencyView}
                          rewards={
                            otherRewards?.length > 0
                              ? otherRewards?.sort((a, b) =>
                                  moment(a?.expires_at).diff(
                                    moment(b?.expires_at)
                                  )
                                )
                              : []
                          }
                        />

                        {!isProfileComplete && (
                          <CompleteProfileCard
                            loyaltyData={loyaltyData}
                            customerData={customerData}
                            setIsLoading={setIsLoading}
                            currencyView={currencyView}
                            isCashbackLoyalty={isCashbackLoyalty}
                          />
                        )}

                        {(loyaltyData?.is_active ||
                          shortLinkType === "loyalty_test") && (
                          <>
                            <LockedLoyaltyCard
                              loyaltyData={loyaltyData}
                              currencyView={currencyView}
                              storeName={storeName || ""}
                              pointsObj={{
                                order_value: initData?.order_value,
                                current_points: initData?.total_points,
                                lifetime_spent: initData?.lifetime_spent,
                              }}
                            />
                            <div
                              className="how-to-redeem"
                              style={{
                                maxWidth: loyaltyData?.settings
                                  ?.advanced_cashback?.is_active
                                  ? "414px"
                                  : "360px",
                              }}
                            >
                              <h3>How to Redeem?</h3>
                              <p>
                                Give your mobile number to the staff on your
                                next purchase and ask them to redeem.
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      <FeedbackModal
                        storeId={storeId}
                        isOpen={isFbModal}
                        storeName={storeName}
                        custData={customerData}
                        shortCode={params.code}
                        activeStep={fbActiveStep}
                        loyaltyData={loyaltyData}
                        currencyView={currencyView}
                        setActiveStep={setFbActiveStep}
                        txnData={initData?.feedback?.data}
                        totalPoints={initData?.total_points}
                        isProfileComplete={isProfileComplete}
                        isCashbackLoyalty={isCashbackLoyalty}
                        fbData={initData?.feedback?.settings}
                        isLoyaltyActive={loyaltyData?.is_active}
                        toggleModal={() => toggleFbModal(!isFbModal)}
                        pointsBranding={loyaltyData?.settings?.points_branding}
                        hear_about_us_flag={
                          initData?.feedback?.hear_about_us_flag
                        }
                      />
                      <ExistingCustomerModal
                        initData={initData}
                        isOpen={isReferralModal}
                        loyaltyData={loyaltyData}
                        toggleModal={() =>
                          toggleReferralModal(!isReferralModal)
                        }
                      />
                      {activeStores?.length > 1 && (
                        <AllStoreBottomStickyMenu
                          activeStores={activeStores?.filter(
                            (store) => (store?._id || store?.id) !== storeId
                          )}
                        />
                      )}
                    </div>
                  ) : activeTabForLoyaltyAndMemb === "membership" ? (
                    <SubscribedMemberships
                      subscribedMemberships={subsMembs}
                      showLoyaltyAndMembTabs={showLoyaltyAndMembTabs}
                    />
                  ) : (
                    <></>
                  )}
                  {isShowLoyaltyAndMembTabs && subsMembs?.length > 0 && (
                    <TabSelectButtonGroup
                      tabList={loyaltyMembShortlinkTabs}
                      activeTab={activeTabForLoyaltyAndMemb}
                      extraClass="loyalty-membership-switch-tabs"
                      setActiveTab={setActiveTabForLoyaltyAndMemb}
                    />
                  )}
                </>
              )}
            </>
          ) : shortLinkType === "feedback_negative" ? (
            <div className="neg-fb">
              <NegFbDetailHead
                storeName={storeName}
                fbGiven={initData?.feedback?.data}
                cardData={initData?.feedback?.settings}
              />
              <NegFbDetailCard
                storeName={storeName}
                currencyView={currencyView}
                custData={initData?.customer}
                fbGiven={initData?.feedback?.data}
                cardData={initData?.feedback?.settings}
                purchaseNumber={initData?.purchase_number}
              />
            </div>
          ) : shortLinkType === "negative_feedback_action" &&
            initData?.negative_feedback_reward ? (
            <NegFbActionTerms
              storeDetails={initData?.store_details}
              loyaltyDetails={initData?.loyalty_details}
              lastTxnDate={initData?.last_transaction_date}
              rewardDetails={initData?.negative_feedback_reward}
            />
          ) : shortLinkType === "qr_code" ? (
            <div className="qr-shortlink-root">
              <QrCodeLandingPage
                subsMembs={subsMembs}
                currencyView={currencyView}
                qrCodeData={initData?.qr_code}
                countryCode={initData?.country_code ?? ""}
                customerDetails={initData?.customer_details || {}}
              />
            </div>
          ) : shortLinkType === "qr_code_reward" ? (
            <div className="qr-shortlink-root">
              <QrCodeRewardPage
                currencyView={currencyView}
                qrCodeData={initData?.qr_code}
                resData={initData?.response_data}
              />
            </div>
          ) : shortLinkType === "referral" ? (
            <div className="b2c-existing-shortlink-root">
              <FinalExistingB2cLp
                resData={initData}
                currencyView={currencyView}
              />
            </div>
          ) : shortLinkType === "unsubscribe_link" ? (
            <WhatsappOptOut data={initData} />
          ) : isValidMembershipLink ? (
            <MembershipLandingPage
              isShortlink={true}
              subsMembs={subsMembs}
              currencyView={currencyView}
              memberships={membershipList}
              membPurchaseDetails={membPurchaseDetails}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {params.templateCode && !isEmpty(initTemplateData) && (
        <div className="campaign-shortlink-root">
          {campTemplateData?.reward?.type === "no_discount" ? (
            <NoDiscountCampCard campData={campTemplateData} />
          ) : (
            <CampaignCard data={campTemplateData} />
          )}
        </div>
      )}
      {isShowEmptyState ? (
        <SbEmptyState
          img="/assets/images/ufo.svg"
          title="Sorry, we couldn't find this page."
        />
      ) : (
        <></>
      )}
      <div className="shortlink-footer">
        <PoweredByReeloFooter activeStep={fbActiveStep} />
      </div>
    </div>
  );
};

export default LoyaltyShortlink;

const checkFbExpiry = (delay, purchaseDate) => {
  if (!delay?.trigger || !purchaseDate) return false;

  const purchasedDateTime = moment(purchaseDate);
  const fbExpiredDateTime =
    delay?.trigger === "immediately"
      ? purchasedDateTime?.add(5, "days")
      : delay?.trigger === "delay"
      ? purchasedDateTime
          ?.add(delay?.delay?.duration, delay?.delay?.period)
          ?.add(5, "days")
      : purchasedDateTime;

  return moment().isBefore(fbExpiredDateTime);
};

const getExpiryText = (last_transaction_date, points_expiry) => {
  if (points_expiry?.active && last_transaction_date) {
    const expiryDate = moment(last_transaction_date).add(
      points_expiry.current,
      "months"
    ); // last_transaction_date + add months

    const duration = moment.duration(expiryDate.diff(moment()));
    const expiresInMonths = duration.months();
    const expiresInDays = duration.days();
    const expiresOnText = `on ${expiryDate.format("MMM DD, YYYY")}`;

    return expiresInMonths > 0 || (expiresInMonths === 0 && expiresInDays > 7)
      ? `(Expires ${expiresOnText})`
      : expiresInDays === 0
      ? `(Expires today)`
      : expiresInDays > 0
      ? `(Expires in ${expiresInDays} ${pluralize("days", expiresInDays)})`
      : "";
  }

  return "";
};

const ReferralButton = ({
  initData,
  shortLinkType,
  isReferralModal,
  toggleReferralModal,
}) =>
  !isEmpty(initData?.referral) &&
  initData?.referral?.referral_settings?.status === "active" &&
  (shortLinkType === "loyalty" ||
    shortLinkType === "feedback" ||
    shortLinkType === "loyalty_redemption") ? (
    <div
      className="referral-btn"
      onClick={() => toggleReferralModal(!isReferralModal)}
      style={{
        backgroundColor:
          initData?.loyalty?.colors?.text ||
          initData?.feedback?.settings?.colors?.text,
      }}
    >
      <GiftIcon
        color={
          initData?.loyalty?.colors?.theme ||
          initData?.feedback?.settings?.colors?.theme
        }
      />
      <p
        style={{
          color:
            initData?.loyalty?.colors?.theme ||
            initData?.feedback?.settings?.colors?.theme,
        }}
      >
        Refer your friends
      </p>
    </div>
  ) : (
    <></>
  );

const GiftIcon = ({ color }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 5.54036V18.8737M9.99935 5.54036H7.05292C6.61879 5.54036 6.20243 5.36477 5.89545 5.05221C5.58847 4.73965 5.41602 4.31573 5.41602 3.8737C5.41602 3.43167 5.58847 3.00775 5.89545 2.69519C6.20243 2.38263 6.61879 2.20703 7.05292 2.20703C9.34459 2.20703 9.99935 5.54036 9.99935 5.54036ZM9.99935 5.54036H12.9458C13.3799 5.54036 13.7963 5.36477 14.1032 5.05221C14.4102 4.73965 14.5827 4.31573 14.5827 3.8737C14.5827 3.43167 14.4102 3.00775 14.1032 2.69519C13.7963 2.38263 13.3799 2.20703 12.9458 2.20703C10.6541 2.20703 9.99935 5.54036 9.99935 5.54036ZM16.666 9.70703V16.207C16.666 17.1405 16.666 17.6072 16.4844 17.9637C16.3246 18.2773 16.0696 18.5323 15.756 18.692C15.3995 18.8737 14.9328 18.8737 13.9993 18.8737L5.99935 18.8737C5.06593 18.8737 4.59922 18.8737 4.2427 18.692C3.92909 18.5323 3.67413 18.2773 3.51434 17.9637C3.33268 17.6072 3.33268 17.1405 3.33268 16.207V9.70703M1.66602 6.8737L1.66602 8.3737C1.66602 8.84041 1.66602 9.07376 1.75684 9.25202C1.83674 9.40882 1.96422 9.53631 2.12102 9.6162C2.29928 9.70703 2.53264 9.70703 2.99935 9.70703L16.9994 9.70703C17.4661 9.70703 17.6994 9.70703 17.8777 9.6162C18.0345 9.53631 18.162 9.40883 18.2419 9.25202C18.3327 9.07376 18.3327 8.84041 18.3327 8.3737V6.8737C18.3327 6.40699 18.3327 6.17363 18.2419 5.99537C18.162 5.83857 18.0345 5.71109 17.8777 5.63119C17.6994 5.54037 17.4661 5.54037 16.9993 5.54037L2.99935 5.54036C2.53264 5.54036 2.29928 5.54036 2.12102 5.63119C1.96422 5.71109 1.83674 5.83857 1.75684 5.99537C1.66602 6.17363 1.66602 6.40699 1.66602 6.8737Z"
      strokeWidth="1.64"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color || "#6E4D40"}
    />
  </svg>
);
